export var Z_INDEX_MAX = 9999;